import React from 'react'
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native'
import { grayBorders } from '../../theme/colors'

interface Props {
  customStyle?: StyleProp<ViewStyle>
}

export const Separator = ({ customStyle }: Props) => {
  return <View style={[styles.separator, customStyle]} />
}
const styles = StyleSheet.create({
  separator: {
    borderBottomColor: grayBorders,
    borderBottomWidth: 0.9,
  },
})
